import can from 'can';
import BaseWidget from 'scripts/base-widget';
import 'components/tag-based-related-content-slider/tag-based-related-content-slider';
import dom from 'scripts/utils/dom';

export const TagBasedRelatedContent = BaseWidget.extend({
    init: function() {
        const sliderType = dom.getPageContentFilterType();
        const showSliderTitle =
            sliderType === 'articles' || sliderType === 'videos';
        this.viewModel = {
            sliderType: sliderType,
            showSliderTitle: showSliderTitle,
        };
        this.view = can.stache(
            '<tag-based-related-content-slider type="{{sliderType}}" showtitle="{{showSliderTitle}}"/>',
        );
        this._super();
    },
});
